module.exports = __webpack_public_path__ + "img/255.cef81e14.jpg";